import * as angular from "angular";
import * as _ from "lodash";

export class ContractsDialogService {

  constructor(private $mdDialog) {
  }


  createContract(event) {

    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope, splitService) {

        $scope.cancel = self.$mdDialog.cancel;
        $scope.settlementsArray = [{}]
        $scope.contractName = '';
        $scope.siteProgramTypes = splitService.getSiteProgramTypes();

        //////////////////////
        $scope.onChanges = ({contractName, settlementsArray}) => {
          $scope.contractName = contractName
          $scope.settlementsArray = settlementsArray
        }

        $scope.onAddSettlement = () => {
          $scope.settlementsArray = _.concat($scope.settlementsArray, [{}]);
        }

        $scope.onDeleteSettlement = (index) => {
          const settlementsArrayCopy = angular.copy($scope.settlementsArray);
          settlementsArrayCopy.splice(index, 1);
          $scope.settlementsArray = settlementsArrayCopy;
        }
        $scope.onSetProgramType = ({programType, index}) => {
          const program = _.find($scope.siteProgramTypes, (siteProgram) => {
            return siteProgram.id === programType;
          })
          const settlementsArray = angular.copy($scope.settlementsArray)
          _.set(settlementsArray[index], 'programSetting.name', program.type);
          _.set(settlementsArray[index], 'programType', program.id);
          $scope.settlementsArray = settlementsArray;
        }


        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                contractName: $scope.contractName,
                settlementsArray: $scope.settlementsArray
              });
            }
          }
        }

      },
      template: require('./../views/dialogs/create-contract-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  addProgramTypeToContract(event, contract) {

    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope, splitService) {

        $scope.cancel = self.$mdDialog.cancel;
        $scope.contract = contract;
        $scope.createdProgramType = {};

        $scope.siteProgramTypes = splitService.getSiteProgramTypes();

        //////////////////////
        $scope.onChanges = ({createdProgramType}) => {
          $scope.createdProgramType = angular.copy(createdProgramType);
        }


        $scope.onSetProgramType = ({programType}) => {
          const program = _.find($scope.contract.entryList, (program) => {
            return program.type === programType;
          })
          const createdProgramType = angular.copy($scope.createdProgramType)
          _.set(createdProgramType, 'programSetting.name', program.programSetting.name);
          _.set(createdProgramType, 'programType', program.type);
          $scope.createdProgramType = createdProgramType;
        }


        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.createdProgramType);
            }
          }
        }

      },
      template: require('./../views/dialogs/add-program-to-contract-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editContractName(contract) {

    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        $scope.contract = contract;
        $scope.contractName = contract.name;

        $scope.onChanges = (contractName) => {
          $scope.contractName = angular.copy(contractName);
        }

        $scope.onSubmit = (form) => {
          if (form && form.$valid) {
            self.$mdDialog.hide($scope.contractName);
          }
        }
      },
      template: require('./../views/dialogs/edit-contract-name-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  addContract(excludedContractIds?: string[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-contract-dialog.html').default,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.excludedContractIds = excludedContractIds;

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////

        $scope.onAdd = (contract) => {
          self.$mdDialog.hide(contract);
        }

      }
    })
  }

  // not in use but working. dont delete
  assignToContract(excludedAccountIds: string[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/assign-accounts-to-contract-dialog.html').default,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.excludedAccountIds = excludedAccountIds;
        $scope.selectedIds = excludedAccountIds || [];
        $scope.assignableAccounts = [];

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onSelectedAccountsChanged = (selectedIds) => {
          $scope.selectedIds = angular.copy(selectedIds);
          $scope.assignableAccounts = _.xor($scope.selectedIds, $scope.excludedAccountIds); //Xor because the excluded are always selected
        }

        $scope.onAssign = () => {
          self.$mdDialog.hide($scope.assignableAccounts);
        }

      }
    })
  }

  editContractCarriers(assignedAccountIds: string[]) {
    const self = this;
    return this.$mdDialog.show({
        parent: angular.element(document.body),
        template: require('./../views/dialogs/edit-contract-accounts-dialog.html').default,
        clickOutsideToClose: true,
        fullscreen: true,
        controller: function ($scope) {
          $scope.assignedAccountIds = assignedAccountIds || [];

          $scope.payload = {
            accountIdsToAdd: undefined,
            accountIdsToRemove: undefined
          }

          $scope.cancel = self.$mdDialog.cancel;
          ////////////////////////////////////////////////////////////

          // ******************************
          //        Public methods
          // ******************************

          $scope.onAccountListsChanged = (accountIdsToAdd: string[], accountIdsToRemove: string[]) => {
            $scope.payload = {
              accountIdsToAdd: accountIdsToAdd,
              accountIdsToRemove: accountIdsToRemove
            }
          }

          $scope.onAssign = () => {
            self.$mdDialog.hide({
              accountIdsToAdd: $scope.payload.accountIdsToAdd,
              accountIdsToRemove: $scope.payload.accountIdsToRemove
            });
          }

        }
      }
    )
  }


}

angular
  .module('bringoz.admin.contracts')
  .service('contractsDialogService', ContractsDialogService);
